<template>
  <div id="main-wrapper">
    <div v-if="porPopup">
      <div class="mfp-bg animated zoomIn mfp-ready"></div>
      <div class="mfp-wrap mfp-close-btn-in mfp-auto-cursor animated zoomIn mfp-ready" tabindex="-1" style="overflow: hidden auto;">
        <div class="mfp-container mfp-s-ready mfp-inline-holder">
          <div class="mfp-content">
            <div id="upload-confirm" class="white-popup-block popup-content popup-small">
              <div class="content t-white t-left">
                <p>
                  {{$t('account.mandatory_complete_KYC')}}
                  {{$t('account.submit_proof_address')}}
                  <router-link :to="{ path:'/ticket-details', query : { id: store.user.profile.ticket_id }}" v-if="store.user.profile.ticket_id">{{$t('account.click_here')}}</router-link>
                  {{$t('account.email_to')}}<a href="mailto:contactus@aaafx.com">{{$t('account.contactus_aaafx_com')}}</a>
                </p>
                <p>{{$t('account.following_address_Proofs')}}</p>
                <p>1. {{$t('account.utility_bill')}}</p>
                <p>2. {{$t('account.bank_statement')}}</p>
                <p>3. {{$t('account.government_issued')}}</p>
                <p><strong>{{$t('account.note')}}</strong> {{$t('account.proof_of_address')}} </p>
              </div>
              <div class="btn-holder t-center">
                <a href="#" class="btn btn-lblue close-popup" @click.prevent="porPopup = false" v-if="store.user.verified_status">{{$t('account.ok')}} </a>
                <router-link to="/dashboard" class="btn btn-lblue close-popup" v-else>{{$t('account.ok')}} </router-link>
              </div>
              <button title="Close (Esc)" type="button" class="mfp-close" @click.prevent="porPopup = false">×</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-container profile-page manage-acct live-acct">
      <div class="page-wrap">
        <div class="page-content clearfix">
          <div class="main-content f-left">
            <Form @submit="createAccount">
              <div class="title-holder">
                <h4>{{ form.demo_live == "0" ? "Demo" : "Live" }} {{$t('account.account')}}</h4>
              </div>
              <div class="content-holder">
                <div class="row-sec d-flex align-items-center flex-wrap">
                  <div class="form-holder wow fadeInLeft">
                    <ul class="clearfix">
                      <li>
                        <label for="">{{$t('account.select_platform')}}</label>
                        <Field
                          class="form-control drop-search"
                          as="select"
                          name="platform"
                          rules="required"
                          v-model="form.platform"
                          @change="form.currency?form.currency = '':null;form.account_type?form.account_type = '':null"
                        >
                          <option value="" disabled>{{$t('account.select_platform')}}</option>
                          <option
                            v-for="platform of availablePlatforms"
                            :value="platform.value"
                            :key="platform.value"
                          >
                            {{ platform.label }}
                          </option>
                        </Field>
                        <ErrorMessage name="platform" />
                      </li>
                      <li>
                        <label for="">{{$t('account.select_account_type')}}</label>
                        <Field
                          class="form-control"
                          as="select"
                          name="type"
                          rules="required"
                          v-model="form.account_type"
                          @change="form.currency?form.currency = '':null"
                        >
                          <option value="" disabled>{{$t('account.select_account_type')}}</option>
                          <option
                            v-for="account of availableAccountTypes"
                            :value="account.value"
                            :key="account.value"
                          >
                            {{ account.label }}
                          </option>
                        </Field>
                        <ErrorMessage name="type" />
                      </li>
                      <li>
                        <label class="customCheckBox">
                          
                          <input type="checkbox" name="" v-model="makeAsZulu" />
                          <span class="checkmark"></span>
                          {{$t('account.connect_your_account')}}
                        </label>
                      </li>
                      <li v-if="form.account_type != 'ZULU'"><!-- form.account_type != 'ISL' &&  -->
                        <label for="">{{$t('account.select_leverage')}}</label>
                        <Field
                          class="form-control"
                          as="select"
                          name="leverage"
                          rules="required"
                          v-model="form.leverage"
                        >
                          <option value="" disabled>{{$t('account.select_leverage')}}</option>
                          <option
                            v-for="leverage of static_vars.leverages"
                            :value="leverage.value"
                            :key="leverage.value"
                          >
                            {{ leverage.label }}
                          </option>
                        </Field>
                        <ErrorMessage name="leverage" />
                      </li>
                      <li>
                        <label for="">{{$t('account.select_account_base_currency')}}</label>
                        <Field
                          class="form-control"
                          as="select"
                          name="currency"
                          rules="required"
                          v-model="form.currency"
                        >
                          <option value="" disabled>{{$t('account.select_currency')}}</option>
                          <option
                            v-for="(value, key) in currencyList"
                            :value="key"
                            :key="value"
                          >
                            {{ key }}
                          </option>
                        </Field>
                        <ErrorMessage name="currency" />
                      </li>
                      <li>
                        <label for="">{{$t('account.Password')}}</label>
                        <Field class="form-control" name="password" type="password" :rules="{required: true,min:5, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?!.*[\\\/])(?=.*[!%&@#$^*?_~])\S{5,30}$/}" v-model="form.password" maxlength="15" @focusin="showPassDiv = true" @focusout="showPassDiv = false" v-if="form.platform == 'MT4'"/>
                      <Field class="form-control" name="password" type="password"  :rules="{required: true,min:8, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?!.*[\\\/])(?=.*[!%&@#$^*?_~])\S{8,30}$/}" v-model="form.password" maxlength="15" @focusin="showPassDiv = true" @focusout="showPassDiv = false" v-else/>
                        <ErrorMessage name="password" />
                        <!-- <p><strong>Note: </strong>Minimum 8 character</p> -->
                        <div id="pr-box" class="light" v-show="showPassDiv">
                          <i></i>
                          <div id="pr-box-inner">
                            <p v-if="form.platform == 'MT4'">{{$t('account.minimum_password_length5')}}</p>
                            <p v-else>{{$t('account.minimum_password_length8')}}</p>
                            <ul>
                              <li class="pr-numcharacters">
                                <span
                                  :class="form.password?.length >= 5 ? 'pr-ok' : ''" v-if="form.platform == 'MT4'"
                                ></span>
                                <span
                                  :class="form.password?.length >= 8 ? 'pr-ok' : ''" v-else
                                ></span>{{$t('account.spcl_characters')}}
                              </li>
                              <li class="pr-useLowercase">
                                <span :class="lowercaseOK ? 'pr-ok' : ''"></span
                                >{{$t('account.lowercase_letter')}}
                              </li>
                              <li class="pr-useUppercase">
                                <span :class="uppercaseOk ? 'pr-ok' : ''"></span
                                >{{$t('account.capital_letter')}}
                              </li>
                              <li class="pr-useNumbers">
                                <span :class="numberOk ? 'pr-ok' : ''"></span>{{$t('account.number')}}
                              </li>
                              <li class="pr-useSpecial">
                                <span :class="SpecialCharOk ? 'pr-ok' : ''"></span
                                >{{$t('account.special_character')}}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                      <li>
                        <label for="">{{$t('account.confirm_password')}}</label>
                        <Field
                          class="form-control"
                          name="Confirm Password"
                          type="password"
                          :rules="form.platform == 'MT4' ? 'required|min:5|confirmed:@password' : 'required|min:8|confirmed:@password'"
                          v-model="form.confirmPassword"
                          maxlength="15"
                        />
                        <ErrorMessage name="Confirm Password" />
                      </li>
                    </ul>
                  </div>
                  <div class="guide-holder demo-guide wow fadeInRight" v-if="form.demo_live == '0'">
                    <div class="guide colu">
                      <img src="assets/images/demo-ico1.png" alt="" />
                      <p>{{$t('account.trade_With_virtual_funds')}}</p>
                    </div>
                    <div class="guide colu">
                      <img src="assets/images/demo-ico2.png" alt="" />
                      <p>{{$t('account.test_strategies')}}</p>
                    </div>
                    <div class="guide colu">
                      <img src="assets/images/demo-ico3.png" alt="" />
                      <p>{{$t('account.risk_free_trading')}}</p>
                    </div>
                    <div class="guide colu">
                      <img src="assets/images/demo-ico4.png" alt="" />
                      <p>{{$t('account.live_market_feed')}}</p>
                    </div>
                  </div>
                  <div class="guide-holder demo-guide wow fadeInRight" v-if="form.demo_live == '1'">
                    <div class="guide colu">
                      <img src="assets/images/live-ico1.png" alt="" />
                      <p>{{$t('account.liquidity_from_top')}}</p>
                    </div>
                    <div class="guide colu">
                      <img src="assets/images/live-ico2.png" alt="" />
                      <p>{{$t('account.effective_trading')}}</p>
                    </div>
                    <div class="guide colu">
                      <img src="assets/images/live-ico3.png" alt="" />
                      <p>{{$t('account.instant_execution')}}</p>
                    </div>
                    <div class="guide colu">
                      <img src="assets/images/live-ico4.png" alt="" />
                      <p>{{$t('account.low_commissions')}}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="btn-holder t-left">
                <button type="submit" class="btn btn-yellow popup-link-holder">
                  {{$t('account.create_new')}}
                  {{ form.demo_live == "0" ? "Demo" : "Live" }} {{$t('account.account')}}
                </button>
                <a @click="$router.back()" class="btn btn-blue">{{$t('account.cancel')}}</a>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useMainStore } from "@/store";
import { Form, Field, ErrorMessage } from "vee-validate";


export default {
  setup() {
    const store = useMainStore();
    return { store };
  },
  data() {
    return {
      makeAsZulu: false,
      form: {
        account_type: "",
        demo_live: "0",
        platform: "MT4",
        leverage: "",
        currency: "",
        password: "",
        confirmPassword: ""
      },
      showPassDiv: false,
      lowercaseOK: false,
      uppercaseOk: false,
      numberOk: false,
      SpecialCharOk: false,
      porPopup:false
    };
  },
  watch: {
    "form.password": function (val = '') {
      let lowerCase = new RegExp("[a-z]"),
        upperCase = new RegExp("[A-Z]"),
        numbers = new RegExp("[0-9]"),
        specialcharacter = new RegExp("[!,%,&,@,#,$,^,*,?,_,~]");
      if (val.match(lowerCase)) {
        this.lowercaseOK = true;
      } else {
        this.lowercaseOK = false;
      }
      if (val.match(upperCase)) {
        this.uppercaseOk = true;
      } else {
        this.uppercaseOk = false;
      }
      if (val.match(numbers)) {
        this.numberOk = true;
      } else {
        this.numberOk = false;
      }
      if (val.match(specialcharacter)) {
        this.SpecialCharOk = true;
      } else {
        this.SpecialCharOk = false;
      }
      if (this.lowercaseOK && this.uppercaseOk && this.numberOk &&  this.SpecialCharOk && val.length >= 5 && this.form.platform== "MT4") {
        this.showPassDiv = false;
      }
      if (this.lowercaseOK && this.uppercaseOk && this.numberOk &&  this.SpecialCharOk && val.length >= 8 && this.form.platform== "MT5") {
        this.showPassDiv = false;
      }
    },
  },
  computed: {
    currencyList(){
      if(this.form.account_type == 'ISL'){
        return this.static_vars.currency_ISL
      }else{
        // if(this.store.user.profile.user_id == 20079){
        //   return this.static_vars.currency_mt4
        // }else{
          return this.static_vars.currency_mt4
        //}
      }
    },
    availablePlatforms() {
      if (this.form.demo_live == "1") {
        return this.static_vars.platforms;
      } else {
        return this.static_vars.platforms.filter((i) => i.value != "ZTP");
      }
    },
    availableAccountTypes() {

        return this.static_vars.accountTypes

        // if(this.store.user.profile.user_id == 20079){
        //   return this.static_vars.accountTypes
        // }else{
        //  return this.static_vars.mt5accountTypes
        //}

      // if (this.form.platform== "MT5") {
      //   return this.static_vars.accountTypes.filter(
      //     (i) => i.value != "ISL" && i.value != "ZULU"
      //   );
      // } else {
      //   return this.static_vars.accountTypes
      // }
      /*if (this.form.platform == "ZTP") {
        return this.static_vars.accountTypes.filter(
          (i) => i.value != "ECN" && i.value != "ECNP"
        );
      } else {
        return this.static_vars.accountTypes.filter(
          (i) => i.value == "ECN" || i.value == "ECNP"
        );
      }*/
    },
    forUsers(){
      // return [4668].includes(this.store.user.profile.user_id) ; // dev
      return [20081,41322,40774].includes(this.store.user.profile.user_id) ; // live
    }
  },
  mounted() {
    if (this.$route.query.type) {
      if (this.$route.query.type == "demo") {
        this.form.demo_live = "0";
      } else {
        this.form.demo_live = "1";
        if(this.$route.query.from && this.$route.query.from == 'copy-trading'){
            this.form.account_type = 'ZULU'
        }

      }
    }
  },
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  methods: {
    createAccount() {
      if(this.store.tradingAccounts.records.length >= 1 && this.form.demo_live == "1" && this.store.user.por == 0 && this.forUsers){
        this.porPopup = true
        return;
      }
      let form = JSON.parse(JSON.stringify(this.form));
      /*if(form.account_type == 'ISL' || form.account_type == 'ZULU'){
        form.leverage = "0"
      }*/
      if(this.makeAsZulu) {
        if(form.account_type == 'ISL'){
          form.account_type = "Z"+form.account_type
        }else{
          form.account_type = form.account_type+"Z"
        }
      }
      //console.log("-------------",form)
      this.store.createAccount(form, true);
    },
  },
};
</script>
